import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMailLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 4C21.0544 4 21.9182 4.81588 21.9945 5.85074L22 6V18C22 19.0544 21.1841 19.9182 20.1493 19.9945L20 20H4C2.94564 20 2.08183 19.1841 2.00549 18.1493L2 18V6C2 4.94564 2.81588 4.08183 3.85074 4.00549L4 4H20ZM20 7.41424L13.0606 14.3536C12.4748 14.9394 11.5251 14.9394 10.9393 14.3536L4 7.41424V18H20V7.41424ZM18.5858 6H5.41409L12 12.5859L18.5858 6Z" })
});
export default SvgMailLine;
